var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpaceShipLg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 333,
    viewBox: "0 0 200 333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 333
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 333,
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-536.44 1172.182) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(840.148 544.839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.15,0C244.239,0,352.128,41.011,352.128,91.6s-107.89,91.6-240.979,91.6S81.1,136.458,81.1,85.869-21.939,0,111.15,0Z",
    transform: "translate(-43.06 0)",
    fill: "#858585",
    opacity: 0.74
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.2,0c35.459,0,93.144,30.53,93.144,64.149S99.663,134.477,64.2,134.477,0,104.373,0,67.239,28.745,0,64.2,0Z",
    transform: "translate(138.658 25.071)",
    fill: "#0dcca5",
    opacity: 0.7
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceShipLg);
export default __webpack_public_path__ + "static/media/spaceShip-lg.dc248318a95ae4dec02ef1c552e22a59.svg";
export { ForwardRef as ReactComponent };